import * as actionTypes from "./actionTypes";
import axios from "axios";

export const authStart =()=>{
 return {
     type: actionTypes.AUTH_START
 };
};



export const authSucess =(token , userId)=>{
    return{
        type: actionTypes.AUTH_SUCCESS,
        idToken: token ,
        userId: userId
    };
};


export const authFail =(error)=>{
return{
    type: actionTypes.AUTH_FAIL ,
    error: error
};
};

export const logout =()=>{
   
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');

    return {
        type: actionTypes.AUTH_LOGOUT
    };
};



export const checkAuthTimeout=(expiresin)=>{
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());         
        }, expiresin * 1000);
    }
}



export const auth =(email , password , isSignup) => {
    return dispatch => {
        dispatch(authStart());
       const authData ={
           email: email ,
           password: password ,
           returnSecureToken: true 
       }
       
       let URL = `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=
       AIzaSyBPgHsDLguTMw4-R9k7KJZ6svpgnvZjkCw`;
       
       if(!isSignup) {
        URL = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBPgHsDLguTMw4-R9k7KJZ6svpgnvZjkCw`;
       };

       axios.post( URL , authData ) 
        .then(response => {
            console.log(response)
            const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
            localStorage.setItem('token' , response.data.idToken);
            localStorage.setItem('expirationDate' , expirationDate);
            localStorage.setItem("userId" , response.data.localId);
            dispatch(authSucess(response.data.idToken , response.data.localId));
            dispatch(checkAuthTimeout(response.data.expiresIn));
        })
        .catch(error => {
            console.log(error)
            dispatch(authFail(error.response.data.error))
        })
    };
};




export const setAuthRedirectPath =(path)=>{
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH ,
        path: path
    }
};



export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (expirationDate <= new Date()) {
                dispatch(logout());
            } else {
                const userId = localStorage.getItem('userId');
                dispatch(authSucess(token, userId));
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000 ));
            }   
        }
    };
};